import {ChangeDetectionStrategy, Component, computed, effect, inject, input} from '@angular/core';
import {MatButtonModule} from "@angular/material/button";
import {MatTableModule} from "@angular/material/table";
import {MatIconModule} from "@angular/material/icon";
import {Store} from '@ngrx/store';
import {MatDialog} from '@angular/material/dialog';
import {ScreeningCriteriaDTO} from '../../dto/screening-criteria';
import {selectScreeningCriteriaState} from '../../services/screening-criteria/screening-criteria.selectors';
import {loadScreeningCriterias} from '../../services/screening-criteria/screening-criteria.actions';
import {ScreeningCriteriasDialogComponent} from '../screening-criterias-dialog/screening-criterias-dialog.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {map} from 'rxjs/operators';
import {MatCardModule} from '@angular/material/card';
import {getStatement} from '../../helper/screening-criteria';
import {MatTooltip} from '@angular/material/tooltip';
import {InfoCardComponent} from '../../../../utils/components/info-card/info-card.component';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-screening-criterias-list',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatToolbarModule,
    MatCardModule,
    MatTooltip,
    InfoCardComponent
  ],
  templateUrl: './screening-criterias-list.component.html',
  styleUrl: './screening-criterias-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScreeningCriteriasListComponent {
  private readonly store: Store = inject(Store);
  private readonly dialog: MatDialog = inject(MatDialog);
  private readonly breakpointObserver: BreakpointObserver = inject(BreakpointObserver);
  readonly projectId = input.required<number>();
  readonly editable = input<boolean>(true);

  private readonly criteriaState = this.store.selectSignal(selectScreeningCriteriaState);
  readonly criterias = computed(() => this.criteriaState().criteriaByProject[this.projectId()] ?? []);

  displayedColumns: string[] = ['and', 'includeCriteria', 'name', 'criteria'];
  readonly isSmallScreen = toSignal(
    this.breakpointObserver.observe([Breakpoints.Handset]).pipe(map(result => result.matches)),
    {initialValue: false}
  );

  constructor() {
    effect(() => {
      this.store.dispatch(loadScreeningCriterias({projectId: this.projectId()}));
    });
  }

  create(): void {
    if (!this.editable()) {
      return;
    }
    this.dialog.open(ScreeningCriteriasDialogComponent, {
      width: '1000px',
      maxWidth: '95vw',
      autoFocus: false,
      data: {projectId: this.projectId()},
    });

  }

  openDialog(criteria?: ScreeningCriteriaDTO): void {
    if (!this.editable()) {
      return;
    }
    this.dialog.open(ScreeningCriteriasDialogComponent, {
      width: '1000px',
      maxWidth: '95vw',
      autoFocus: false,
      data: {
        criteria: criteria,
        projectId: this.projectId(),
      },
    });
  }

  getPreviewStatement(criteria: ScreeningCriteriaDTO) {
    return getStatement(criteria.includeCriteria ?? true, criteria.criteria);
  }

}
